var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-page no-campaign"},[_c('h1',[_vm._v("ไม่พบ Campaign")]),_c('p',[_vm._v(" ขออภัยไม่มี Campaign ที่คุณกำลังหา ")])])
}]

export { render, staticRenderFns }